<template>
  <div>
    <v-dialog
      v-model="mapDialog"
      max-width="1000"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">View Map</h3>
        <div class="caption mb-3">Pan and zoom around the map</div>
        <div id="map" class="mt-3"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import $Scriptjs from 'scriptjs'

export default {
  props: {
    latitude: {
      type: Number,
      required: true
    },
    longitude: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      mapDialog: false,
      marker: {}
    }
  },

  created () {
  },

  mounted () {
    $Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + process.env.VUE_APP_GOOGLE_API_KEY + '&v=weekly', () => {
    })
  },

  methods: {
    showMap: function () {
      this.initMap()
      this.mapDialog = true
    },
    initMap: function () {
      var _this = this
      if (_this.latitude !== 0 && _this.longitude !== 0) {
        _this.loadMap(_this.latitude, _this.longitude)
      }
    },
    loadMap: function (lat, lng) {
      let _this = this
      let google = window.google
      const center = { lat: lat, lng: lng }
      const map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: 18
      })

      // marker
      _this.marker = new google.maps.Marker({
        position: center,
        map,
        draggable: false,
        title: 'Recipient'
      })
      console.log('lat: ' + _this.marker.getPosition().lat())
      console.log('lng: ' + _this.marker.getPosition().lng())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#map {
  height: 400px;
  width: 100%;
}

</style>
